export class ContractMenuItem
{
    ContractName: string;
    ContractNumber: string;
    ContractUrl: string;
    Branch : string;
}